import {compose} from "recompose";
import {connect} from "react-redux";
import UserOverviewPage from "./UserOverviewPage";
import {saveResourceFieldAction} from "../../../../resources/actions";
import {groupsUserMayAddTo} from "../../../../components/composites/UserGroupDropdown";
import {injectIntl} from "react-intl";

const mapState = (state, props) => {
    return {
        groups: groupsUserMayAddTo(state, props)
    }
};

const mapDispatch = (dispatch, ownProps) => {
    let user = ownProps.user;
    return {
        saveUserGroups: (groups) => (groupId) => {
            // find selected group; the "—" option (value "none") is treated as the "No Access" group
            let selected = groupId === 'none'
                ? groups.find((group) => group.name === 'none')
                : groups.find((group) => group.id === groupId);

            if (!selected) {
                return;
            }

            let fieldPath = ["userProfile", "partnerGroups"];

            let partnerGroup = {
                groupId: selected.id,
                partnerId: selected.partnerId
            };

            dispatch(saveResourceFieldAction(
                user.resourceId,
                user.resourceId,
                [],
                fieldPath,
                fieldPath.join("."),
                JSON.stringify([partnerGroup]),
                [user.resourceId]
            ));
        }
    }
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    // make final dispatch function injecting groups from state props
    return {
        ...ownProps,
        saveUserGroups: dispatchProps.saveUserGroups(stateProps.groups)
    }
};

const UserOverviewPageComposed = compose(
    injectIntl,
    connect(mapState, mapDispatch, mergeProps),
)(UserOverviewPage);

export default UserOverviewPageComposed;


// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/tabPanes/UserOverviewPageContainer.jsx